import { useMutation } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { UploadImageResponse } from '@/api/handlers/resources/images/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import type { ImagePurpose } from '@/api/models';
import type { ImageUploadPayload } from '@/components/imageCropUpload';

export type UploadImageVariables = {
    payload: ImageUploadPayload;
    purpose: ImagePurpose;
};

export const useUploadImageMutation = () => {
    const { apiClient } = useApi();

    return useMutation<
        ApiResponse<UploadImageResponse>,
        Error,
        UploadImageVariables
    >({
        mutationFn: ({ payload, purpose }) =>
            apiClient.images.uploadImage(payload, purpose),
    });
};
